var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"titleHack"},[(_vm.existNow)?_c('img',{directives:[{name:"local-img",rawName:"v-local-img",value:(_vm.sauce),expression:"sauce"}],attrs:{"classes":_vm.classes}}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }